import React from 'react'
import useCarousel from 'hooks/carouselTimer' // Basic Position Logic
import NextIcon from 'svg/nextIcon.svg'
import PreviousIcon from 'svg/prevIcon.svg'
import DotsIndexIndicator from 'components/DotsIndexIndicator'
import styles from './Carousel.module.scss'
type CarouselProps = {
  data: Array<Object>
  children: React.ReactElement<React.ComponentProps<any>, any>
  styleOverride: string
}

const Carousel = ({ data, children, styleOverride }: React.PropsWithChildren<CarouselProps>) => {
  const { nextPosition, position, prevPosition, setPosition } = useCarousel({
    items: data.length,
    enableTimer: false,
    timerDuration: 3000,
  })

  const handlePrevPosition = (ev: React.SyntheticEvent<HTMLButtonElement>) => {
    ev.preventDefault()
    prevPosition()
  }

  const handleNextPosition = (ev: React.SyntheticEvent<HTMLButtonElement>) => {
    ev.preventDefault()
    nextPosition()
  }

  return (
    <div className={`${styles.carouselWrapper} ${styleOverride}`}>
      <div className={styles.controls}>
        {position > 0 && (
          <button
            data-action='previous'
            className={styles.previous}
            type='button'
            onClick={handlePrevPosition}
            onKeyPress={handlePrevPosition}
          >
            <PreviousIcon />
          </button>
        )}
        <button
          data-action='next'
          type='button'
          className={styles.next}
          onClick={handleNextPosition}
          onKeyPress={handleNextPosition}
        >
          <NextIcon />
        </button>
      </div>

      <div className={styles.carousel}>
        <ul
          style={{
            transform: `translateX(-${position * 100}%)`,
          }}
        >
          {children}
        </ul>
      </div>
      <div className={styles.dots}>
        <DotsIndexIndicator
          index={position}
          length={data.length}
          setIndex={setPosition}
          navIndex={position}
        />
      </div>
    </div>
  )
}

export default Carousel
